import { DisplayTag } from "./types";

function compareByRank(a: DisplayTag, b: DisplayTag) {
  return a.rank - b.rank;
}

function compareByDisplayName(a: DisplayTag, b: DisplayTag) {
  return a.displayName.localeCompare(b.displayName);
}

type TagViewComparator = (a: DisplayTag, b: DisplayTag) => number;
function combineComparators(...comparators: TagViewComparator[]): TagViewComparator {
  return (a: DisplayTag, b: DisplayTag) => {
    for (const comparator of comparators) {
      const result = comparator(a, b);
      if (result !== 0) return result;
    }
    return 0;
  };
}

export const compareTag = combineComparators(compareByRank, compareByDisplayName);
